import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { MonthlyReportData } from '@app/models/row-data.interface';
import { Endpoint } from '@app/constants/endpoints.constants';
import { ExportType } from '@app/shared/components/export-box/export-box.constants';

import { ColumnLayout } from '../models/columns-layout';

const url = `${Endpoint.Timesheets}${Endpoint.Report}${Endpoint.Settings}`;

@Injectable({
  providedIn: 'root'
})
export class MonthlyReportRepoService {
  constructor(private _httpClient: HttpClient) {}

  getAdminSettings(): Observable<ColumnLayout[]> {
    return this._httpClient.get<ColumnLayout[]>(url);
  }

  changeColumnsLayout(columnsLayout: ColumnLayout[]): Observable<ColumnLayout[]> {
    return this._httpClient.patch<ColumnLayout[]>(url, columnsLayout);
  }

  getReportData(date: Date): Observable<MonthlyReportData[]> {
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString();
    const params = new HttpParams().set('year', year).set('month', month);
    return this._httpClient.get<MonthlyReportData[]>(Endpoint.Timesheets + Endpoint.Report, { params });
  }

  exportReport(year: number, month: number, filename: string, format: ExportType): Observable<HttpResponse<Blob>> {
    return this._httpClient.get<Blob>(Endpoint.ExportReport, {
      params: { year: year.toString(), month: month.toString(), filename, format },
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }
}
